import React from 'react';

import { Container } from './styles';

const ContactSuccess: React.FC = () => {
  return (
    <Container>
      <span role="img" aria-label="Parabéns">
        🎉
      </span>
      <h1>Solicitação concluída</h1>
      <h4>
        Agradecemos pelo interesse em fazer parte dos nossos restaurantes
        parceiros. Nossa equipe entrará em contato com você em breve!
      </h4>
    </Container>
  );
};

export default ContactSuccess;
